import styled from 'styled-components'

export const PriceBox = styled.div`
  background-color: #f7f7f7;
  border: 1px solid #ececec;
  border-radius: 8px;
  width: 285px;
`
